module.exports = new __parcel__URL__("22721_sq.c9e768a1.jpg").toString();